
export const platformBenefits = {
  title: "Why Choose Bespire?",
  subtitle: "Our platform provides all the tools a creator needs to build a successful online business",
  benefits: [
    {
      title: "Time Saving",
      description: "With our AI assistant, you can create your professional page in minutes, without programming knowledge",
      checks: [
        "Quick setup and smart content suggestions", 
        "Automated tasks and administration"
      ]
    },
    {
      title: "Community Building",
      description: "Build deeper connections with your fans through personal interactions and exclusive content",
      checks: [
        "Paid messaging and consultations", 
        "Personalized video messages"
      ]
    },
    {
      title: "Security and Privacy",
      description: "Our platform provides a secure environment for all creators and fans",
      checks: [
        "Secure payment system", 
        "GDPR-compliant data management"
      ]
    },
    {
      title: "Growth and Expansion",
      description: "Our tools and analytics help your business grow continuously and discover new opportunities",
      checks: [
        "Detailed audience analysis", 
        "Personalized growth tips"
      ]
    }
  ],
  learnMore: "Learn more",
  stats: [
    { value: "300+", label: "Satisfied creators" },
    { value: "98%", label: "Customer satisfaction" },
    { value: "10x", label: "Faster startup" },
    { value: "24/7", label: "Support" }
  ]
};
